import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField } from "@mui/material";
import { format, isValid, parse } from "date-fns";
import TextFieldComponent from "./TextFieldComponent";
import { TimePicker } from "@mui/x-date-pickers";

const TimePickerComponent = ({
  value: selected,
  name,
  label,
  onChange,
  error,
  isMandatory = false,
}) => {
  // Parse string back to valid Date object
  const parsedDate =
    selected && typeof selected === "string"
      ? parse(selected, "HH:mm", new Date())
      : selected instanceof Date
      ? selected
      : null;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <TimePicker
        ampm={false}
        label={
          <span>
            {label}
            {isMandatory && <span className="text-error"> *</span>}
          </span>
        }
        value={parsedDate}
        onChange={newValue => {
          if (newValue && isValid(newValue)) {
            const formatted = format(newValue, "HH:mm");
            onChange({ target: { name, value: formatted } });
          } else {
            onChange({ target: { name, value: "" } });
          }
        }}
        format="HH:mm"
        slotProps={{
          textField: {
            error: !!error,
            helperText: error,
          },
        }}
        sx={{
          "& .MuiFormLabel-root": {
            position: "static",
            color: "#44475a !important",
          },
          "& .MuiInputBase-input": {
            borderTop: "1px solid #eaeadc",
          },
          "& .MuiButtonBase-root": {
            margin: "0",
          },
        }}
        renderInput={params => <TextFieldComponent {...params} />}
      />
    </LocalizationProvider>
  );
};

export default TimePickerComponent;
